/**
 * Error thrown by the HTTP client for a non-successful response, carrying the
 * HTTP status so retry logic can distinguish retryable failures (5xx, 429)
 * from terminal ones (4xx), and the service's error code when it sent one.
 */
class RequestError extends Error {
  readonly status?: number

  readonly code?: string

  constructor(message: string, status?: number, code?: string) {
    super(message)
    this.name = 'RequestError'
    this.status = status
    this.code = code

    // Restore the prototype chain (required when extending built-ins with a
    // pre-ES2015 compilation target).
    Object.setPrototypeOf(this, RequestError.prototype)
  }
}

const parseErrorCode = (text: string): string | undefined => {
  try {
    const errorCode = JSON.parse(text)?.error_code

    return typeof errorCode === 'string' ? errorCode : undefined
  } catch {
    return undefined
  }
}

const toRequestError = (text: string, status: number): RequestError =>
  new RequestError(`Request failed: ${text}`, status, parseErrorCode(text))

export { RequestError, toRequestError }
